<template>
    <v-container>

        <!-- Modal de pago exitoso -->
        <PagoExitoModal v-if="pagoExitoso" :pago="pagoExitoso"/>
        <v-row>
            <v-col cols="12"  :md="pagoExitoso ? 12 : 6">
                <v-card class="pa-4" outlined style="max-width: 380px; margin: auto; border-radius: 14px;">

                    <!-- Encabezado -->
                    <div class="text-center mb-4">
                        <h3 class="font-weight-bold mb-1">RECIBO DE PAGO <v-chip :color="pagoExitoso ? 'green darken-2' : 'red darken-2'" dark small>
                                {{ pagoExitoso ? 'PAGADO' : 'PENDIENTE' }}
                            </v-chip></h3>
                        
                        <v-divider></v-divider>
                    </div>

                    <!-- Datos principales -->
                    <div class="mb-3">
                        <v-row dense>
                            <v-col cols="6">
                                <p class="mb-1"><strong>ID Pago:</strong> {{ recibo.idPago }}</p>
                                <!-- <p class="mb-1"><strong>Contrato:</strong> {{ recibo.contrato }}</p> -->
                            </v-col>

                            <v-col cols="6">
                                <p class="mb-1"><strong>Contrato:</strong> {{ recibo.contrato }}
                                </p>
                                <!-- <p class="mb-1"><strong>Plan:</strong> {{ recibo.plan }}</p> -->
                            </v-col>
                        </v-row>
                    </div>

                    <v-divider class="my-2"></v-divider>

                    <!-- Fechas -->
                    <!-- <div class="mb-3">
                        <p class="font-weight-bold mb-1">Periodo:</p>

                        <v-row dense>
                            <v-col cols="6">
                                <p class="mb-1"><small>Inicio:</small><br>{{ recibo.fecIni }}</p>
                            </v-col>
                            <v-col cols="6">
                                <p class="mb-1"><small>Fin:</small><br>{{ recibo.fecFin }}</p>
                            </v-col>
                        </v-row>
                    </div> 

                    <v-divider class="my-2"></v-divider>
                    -->
                    <!-- Montos -->
                    <div class="mb-3">
                        <p class="font-weight-bold mb-1">Montos:</p>
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <td><strong><strong>Recibo {{ recibo.numPago }} de {{ recibo.numPago }}</strong></strong></td>
                                    <td class="text-right">
                                       <strong>{{ $formatCurrency(recibo.montoPago + recibo.gastoExp) }}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <!-- <p class="mb-1">
                            Monto: <strong>{{ $formatCurrency(recibo.montoPago) }}</strong>
                        </p>
                        <p class="mb-1">
                            Gastos de expedición: <strong>{{ $formatCurrency(recibo.gastoExp) }}</strong>
                        </p> -->
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <div v-if="recibo.pagosPendientes?.length" class="mb-3">
                        <p class="font-weight-bold mb-2">Pagos Pendientes:</p>

                        <v-simple-table dense>
                            <tbody>
                                <tr v-for="(p, i) in recibo.pagosPendientes" :key="i">
                                    <td><strong>Recibo {{ p.numPago }} de {{ p.numPago }}</strong></td>
                                    <td class="text-right">
                                        {{ $formatCurrency(p.montoPago + p.gastoExp) }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <v-divider class="my-2"></v-divider>

                    <!-- Estado -->
                    <!-- <div class="text-center my-2">
                        <strong>Estado del Pago:</strong>
                        <div class="mt-1">
                            <v-chip :color="recibo.isPagado ? 'green darken-2' : 'red darken-2'" dark small>
                                {{ recibo.isPagado ? 'PAGADO' : 'PENDIENTE' }}
                            </v-chip>
                        </div>
                    </div> 

                    <v-divider class="my-2"></v-divider>-->

                    <!-- Total -->
                    <div class="text-right mt-1">
                        <p class="text-h6 font-weight-bold mb-0">
                            Total: {{ $formatCurrency(totalPago) }}
                        </p>
                    </div>

                </v-card>
            </v-col>
            <!-- Encabezado estilo Conekta -->
            <v-col v-if="!recibo.isPagado && !this.pagoExitoso" cols="12" md="6">
                <v-card flat class="pa-4" outlined>

                    <v-row class="align-center">
                        <v-col cols="12" class="d-flex align-center">

                            <div class="subtitle-2 font-weight-bold text-uppercase mr-2" style="color:#8A8FA3;">
                                PAGOS SEGUROS CON
                            </div>

                            <v-img src="https://medicover.mx/img/conekta.webp" max-width="120" contain></v-img>

                            <v-spacer></v-spacer>

                            <v-icon color="#8A8FA3">mdi-information-outline</v-icon>
                        </v-col>
                    </v-row>

                    <v-divider class="mt-2"></v-divider>
                    <v-form ref="formPago" v-model="formValido" lazy-validation>

                        <v-row dense>

                            <!-- Nombre -->
                            <v-col cols="12">
                                <v-text-field label="Nombre en la tarjeta" outlined dense
                                    prepend-inner-icon="mdi-account" v-model="card.name"
                                    :rules="[rules.ruleRequired, rules.ruleNombre]"
                                    @input="card.name = card.name?.toUpperCase()" />
                            </v-col>

                            <!-- Email & Tel -->
                            <v-col cols="6">
                                <v-text-field label="Correo electrónico" outlined dense v-model="correo"
                                    prepend-inner-icon="mdi-email" :rules="[rules.ruleRequired, rules.ruleEmail]" />
                            </v-col>

                            <v-col cols="6">
                                <v-text-field label="Teléfono" outlined dense v-model="telefono"
                                    prepend-inner-icon="mdi-phone" :rules="[rules.ruleRequired, rules.ruleTelephone]" />
                            </v-col>

                            <!-- Tarjeta -->
                            <v-col cols="10">
                                <v-text-field label="Número de tarjeta" outlined dense
                                    prepend-inner-icon="mdi-credit-card" v-mask="'#### #### #### ####'"
                                    v-model="card.number" @input="changeNumTarjet"
                                    :rules="[rules.ruleRequired, ruleCardNumber]" maxlength="19" />
                            </v-col>

                            <!-- Logos -->
                            <v-col cols="2" class="text-center">
                                <v-img v-show="!visa" height="40" contain src="https://medicover.mx/img/visa.svg" />
                                <v-img v-show="!mastercard" height="40" contain
                                    src="https://medicover.mx/img/mastercard.svg" />
                            </v-col>

                        </v-row>

                        <v-row dense>

                            <!-- Mes -->
                            <v-col cols="4">
                                <v-select label="Mes" outlined dense v-model="card.exp_month"
                                   :items="months"
                                    :rules="[rules.ruleRequired]" />
                            </v-col>

                            <!-- Año -->
                            <v-col cols="4">
                                <v-select label="Año" outlined dense v-model="card.exp_year"
                                    :items="years"
                                    :rules="[rules.ruleRequired]" />
                            </v-col>

                            <!-- CVV -->
                            <v-col cols="4">
                                <v-text-field label="CVV" outlined dense v-mask="'###'" type="password"
                                    prepend-inner-icon="mdi-lock" maxlength="3" v-model="card.cvc"
                                    :rules="[rules.ruleRequired]" />
                            </v-col>

                            <!-- Botón Pago -->
                            <v-col cols="12">
                                <!-- <v-btn color="azulMarino" class="white--text" :disabled="!formValido || totalPago <= 0 || this.pagando"
                                    @click="crearToken" block>
                                    <v-icon left>mdi-lock</v-icon>
                                    Pagar de forma segura ${{ totalPago.toFixed(2) }}
                                </v-btn> -->
                                <v-btn color="azulMarino" class="white--text" :disabled="!formValido || totalPago <= 0 || this.pagando"
                                    @click="crearToken" block>
                                    <v-icon left>mdi-lock</v-icon>
                                      <v-progress-circular
                                        v-if="pagando"
                                        indeterminate
                                        size="20"
                                        width="3"
                                        color="white"
                                        class="mr-2"
                                    ></v-progress-circular>
                                    <strong v-show="this.pagando">PAGANDO...  </strong><strong v-show="!this.pagando">PAGAR DE FORMA SEGURA </strong> ${{ totalPago.toFixed(2) }}
                                </v-btn>
                            </v-col>

                            <!-- Política -->
                            <v-col cols="12" class="text-center">
                                <politica-privacidad />
                            </v-col>

                        </v-row>
                    </v-form>

                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import PoliticaPrivacidad from '@/components/Pagos/politicaPrivacidadComponent.vue'
import PagoExitoModal from '@/components/Pagos/modalPagoRealizado.vue'

export default {
    props: {
        recibo: {
            type: Object,
            required: true
        }
    },
    components: {
        PoliticaPrivacidad,
        PagoExitoModal
    },
    computed: {
        totalPago() {
            const recibo = this.recibo || {};
            const pendientes = Array.isArray(recibo.pagosPendientes)
                ? recibo.pagosPendientes
                : [];

            let total = 0;

            // 1. Agregar monto del recibo actual si NO está pagado
            if (recibo.isPagado === 0) {
                total += (recibo.montoPago || 0) + (recibo.gastoExp || 0);
            }

            // 2. Agregar pagos pendientes
            pendientes.forEach(p => {
                if (p.isPagado === 0) {
                    total += (p.montoPago || 0) + (p.gastoExp || 0);
                }
            });

            return total;
        },
        rules() {
            return this.$rules;
        },
        Carrito() {
            const recibo = this.recibo || {};
            const pagos = [];

            // Agregar el pago actual (si no está pagado)
            if (recibo.isPagado === 0) {
                pagos.push({
                    name: `Pago ID: ${recibo.idPago} `,
                    unit_price: ((recibo.montoPago || 0) + (recibo.gastoExp || 0)),
                    quantity: 1
                });
            }

            // Agregar pagos pendientes si existen
            const pendientes = Array.isArray(recibo.pagosPendientes) ? recibo.pagosPendientes : [];

            pendientes.forEach(p => {
                if (p.isPagado === 0) {
                    pagos.push({
                        name: `Pago ID: ${p.idPago}`,
                        unit_price: ((p.montoPago || 0) + (p.gastoExp || 0)),
                        quantity: 1
                    });
                }
            });

            return pagos;
        }
    },
    mounted() {
        if (typeof Conekta !== 'undefined') {
            //eslint-disable-next-line no-undef
            Conekta.setPublicKey(process.env.VUE_APP_CONEKTA_PUBLIC_KEY); // Reemplaza con tu llave pública
        } 
        /*else {
            console.error('Conekta no está definido. Verifica que se cargó el script correctamente.');
        }*/
    },
    data() {
        return {
            pagando: false,
            pagoExitoso: null,
            correo: '',
            telefono: '',
            card: {
                //  number: '4000 0000 0000 9995',//fondos insuficientes
                // number: '4242424242424242', //rechazada
                //number: '4000 0000 0000 3220' //3D Secure requerido
                // number: '4000 0000 0000 9234', //error banko
                //number: '4000 0000 0000 0119', //declinada
                // number: '5105 1051 0510 5100', //mastercard
                number: '', //5105105105105100
                name: '',
                exp_month: '',
                exp_year: '',
                cvc: '',
                // exp_month: '08',
                // exp_year: '2026',
                // cvc: '123',
            },
            months: [
                { text: '01', value: '01' },
                { text: '02', value: '02' },
                { text: '03', value: '03' },
                { text: '04', value: '04' },
                { text: '05', value: '05' },
                { text: '06', value: '06' },
                { text: '07', value: '07' },
                { text: '08', value: '08' },
                { text: '09', value: '09' },
                { text: '10', value: '10' },
                { text: '11', value: '11' },
                { text: '12', value: '12' },
            ],
            years: Array.from({ length: 6 }, (_, i) => String(new Date().getFullYear() + i)),

            ruleCardNumber: (v) =>
                /^4\d{3} \d{4} \d{4} \d{4}$|^5[1-5]\d{2} \d{4} \d{4} \d{4}$/.test(v) ||
                "Tarjeta inválida (Visa/Mastercard)",
            ruleExpDate: (v) => {
                if (!/^\d{2}\/\d{2}$/.test(v)) return "Formato inválido (MM/AA)";
                const [mes, año] = v?.split("/").map(Number);
                const añoActual = new Date().getFullYear() % 100;
                const mesActual = new Date().getMonth() + 1;
                if (año < añoActual || (año === añoActual && mes < mesActual))
                    return "Tarjeta expirada";
                return true;
            },
            ruleCVV: (v) => /^\d{3}$/.test(v) || "CVV inválido (3 dígitos)",
            visa: true,
            mastercard: true,
            formValido: false,
            Id: null,
            headers: [
                { text: '# recibo', value: 'numPago' },
                { text: 'Fecha de Pago', value: 'pagoFecha' },
                { text: 'Monto', value: 'montoPago' },
                { text: 'Gasto Exp.', value: 'gastoExp' },
                { text: 'Estado', value: 'isPagado' }
            ]
        };
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '';
            return new Date(dateStr).toLocaleDateString();
        },
        procesarPago() {
            if (this.$refs.formPago.validate()) {
                alert("✅ Pago exitoso con la tarjeta de " + this.Pago.Titular);
            }
        },
        changeNumTarjet(value) {
            let firstChar1 = value[0];
            if (firstChar1 === "4") { //visa
                this.mastercard = true
                this.visa = false
            }
            if (firstChar1 === "5") {//mastercard
                this.visa = true
                this.mastercard = false
            }
        },
        crearToken() {
            //eslint-disable-next-line no-undef
            Conekta.Token.create({ card: this.card }, this.tokenSuccess, this.tokenError);
        },
        tokenSuccess(token) {
            
            const esValido = this.$refs.formPago.validate();
            if (esValido) {
                this.pagando = true
                this.$http.post(`pagolinea/CrearPago`, {
                    tokenId: token.id,
                    nombre: this.card.name,
                    email: this.correo, // puedes pedirlo en formulario
                    telefono: this.telefono,
                    carrito: this.Carrito,
                    amount: this.totalPago
                })
                    .then(response => {
                        //console.log(response)
                        this.pagoExitoso = response.data.orden
                        this.card = {}
                        //this.recibo.isPagado = true

                    })
                    .catch((err) => {
                        let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';

                        if (err.response) {
                            console.log(err.response)
                            mensajeError = err.response.data?.mensaje
                            /*
                            const detalles = err.response.data?.details;
    
                            if (Array.isArray(detalles) && detalles.length > 0) {
                                // Muestra los mensajes de detalle que da Conekta
                                mensajeError = detalles.map(e => `<p>${e.message}</p>`).join('');
                            } else if (err.response.data?.message) {
                                mensajeError = `<p>${err.response.data.message}</p>`;
                            }
                                */
                        }

                        this.$swal.fire({
                            position: 'center',
                            html: mensajeError,
                            icon: 'error',
                            confirmButtonText: 'Cerrar',
                            showCloseButton: true,
                            showConfirmButton: true,
                            backdrop: false
                        });
                    })
                    .finally(() => {
                        this.pagando = false
                    });
            }
        },
        tokenError(response) {
            console.log("Error Conekta:", response);

            const errores = {
                expired_card: "La tarjeta ha expirado.",
                card_declined: "La tarjeta fue rechazada.",
                insufficient_funds: "Fondos insuficientes.",
                stolen_card: "La tarjeta está reportada como robada.",
                processing_error: "Hubo un error procesando la tarjeta.",
                invalid_number: "El número de tarjeta no es válido.",
                invalid_expiry: "La fecha de expiración no es válida.",
                invalid_cvc: "El código de seguridad (CVC) no es válido.",
                invalid_card: "La tarjeta no es válida.",
                duplicate_charge: "El cargo ya fue procesado.",
            };

            // mensaje traducido por código
            const traducido = errores[response.code];

            // mensaje proporcionado por Conekta
            const original =
                response.message_to_purchaser ||
                response.message ||
                "No fue posible procesar el pago.";

            // Preferimos el traducido si existe
            const mensajeFinal = traducido || original;

            this.$swal.fire({
                position: 'center',
                html: mensajeFinal, 
                icon: 'error',
                confirmButtonText: 'Cerrar',
                showCloseButton: true,
                showConfirmButton: true,
                backdrop: false
            });
        }
    }
};
</script>

<style scoped>
.v-chip {
    font-weight: bold;
}
</style>
